import { Link } from "#src/components/Router.tsx";
import tw from "#src/utils/tw.ts";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  to?: string;
  href?: string;
  style?: React.CSSProperties;
}

export function BorderCard(props: Props) {
  const className = tw(
    "block rounded-md border border-b-3 border-borderGray bg-white px-4 pb-3.5 pt-3 transition-all",
    (props.onClick || props.to || props.href) && "hover:border-[#ccc]",
    props.className
  );

  if (props.to) {
    return (
      <Link
        className={className}
        style={props.style}
        to={props.to}
        onClick={props.onClick}
      >
        {props.children}
      </Link>
    );
  }

  if (props.href) {
    return (
      <a
        className={className}
        style={props.style}
        href={props.href}
        target="_blank"
      >
        {props.children}
      </a>
    );
  }

  return (
    <div className={className} style={props.style} onClick={props.onClick}>
      {props.children}
    </div>
  );
}
